import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact";
import { FormProvider } from "react-hook-form";
import { PersonalDetailsBox } from "./PersonalDetailsBox";
import { CompactContactFormFields } from "./CompactContactFormFields";
export const CompactContactForm = ({ contactFormDatas, tracking, }) => {
    const { methods } = useContactContext();
    return (_jsxs(FormProvider, Object.assign({}, methods, { children: [_jsx(PersonalDetailsBox, {}), _jsx(CompactContactFormFields, { contactFormDatas: contactFormDatas, tracking: tracking })] })));
};
